export default async function apiRequest({ api, method, url, data = null }) {
  try {
    const response = await api[method.toLowerCase()](url, data);
    switch (response.data?.ResponseType) {
      case 'SUCCESS':
        return response.data.Data;

      case 'ERROR':
        throw new Error(response.data.Message);

      default:
        throw new Error('An error occurred. Please try again');
    }
  } catch (error) {
    return {
      error: {
        status: error?.response?.status,
        message: !navigator.onLine
          ? 'Please check your Internet connection'
          : typeof error === 'string'
          ? error
          : error?.response?.data?.Message,
      },
    };
  }
}
